<div class="recipients" [class.recipients--mobile]="isMobile">
  @for (recipient of recipients; track recipient.number) {
    <multi-shipment-entry-card-preview
      [number]="recipient.number"
      [title]="recipient.title"
      [chips]="recipient.chips"
      [rows]="recipient.rows"
      (removePressed)="recipientRemoved.emit()"></multi-shipment-entry-card-preview>
  }

  @if (canAddRecipient) {
    <multi-shipment-add-card-preview
      [card]="addCard"
      (actionPressed)="recipientAdded.emit()"></multi-shipment-add-card-preview>
  }

  @if (itemsToAssign > 0) {
    <div class="recipients__footer">
      <span class="recipients__assign-note" [ngClass]="'recipients__assign-note--' + unassignedWarningTone">
        {{ itemsToAssign }} {{ itemsToAssign === 1 ? 'item' : 'items' }} still
        {{ itemsToAssign === 1 ? 'needs' : 'need' }} to be assigned
      </span>
    </div>
  }
</div>
